import React, { useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import arrow from "./../../assets/images/Arrow.svg";

const Service2 = () => {
  // Liste des services
  const [services, setServices] = useState([
    {
      title: "BILAN COMPTABLE",
      desc: "Confiez-nous vos écritures comptables et la réalisation de votre bilan. On s’occupe de tout pour clôturer votre exercice dans les règles de l’art (et sans migraines).",
    },
    {
      title: "DÉCLARATION DE TVA",
      desc: "Charges sociales, TVA, cotisations… Si tout ça vous donne envie de vous cacher sous votre bureau, laissez-nous gérer. Promis, aucune pénalité de retard ne viendra gâcher la fête.",
    },
    {
      title: "CRÉATION D’ENTREPRISE",
      desc: "Vous avez l’idée, on s’occupe des papiers. Statuts, immatriculation, démarches administratives… Avec nous, votre boîte voit le jour sans stress.",
    },
  ]);

  // State pour gérer l'affichage des nouvelles sections
  const [showNewSections, setShowNewSections] = useState(false);

  // Liste des nouvelles sections prédéfinies
  const newSections = [
    {
      title: "ACCOMPAGNEMENT COMPTABLE",
      desc: "De la tenue de comptes aux déclarations fiscales, on gère tout (et on vous explique tout). Vous pouvez dormir tranquille, on s’occupe de vos chiffres.",
    },
    {
      title: "GESTION QUOTIDIENNE SIMPLIFIÉE",
      desc: "La compta, ça ne doit pas devenir votre pire ennemi. On vous fournit des outils modernes et des conseils personnalisés pour que tout roule.",
    },
    {
      title: "CONSEIL STRATÉGIQUE",
      desc: "Besoin d’un plan pour faire exploser votre croissance ? On analyse vos données et on vous donne les clés pour piloter votre entreprise avec succès.",
    },
  ];

  // Fonction pour basculer l'état d'affichage des nouvelles sections
  const toggleSections = () => {
    setShowNewSections(!showNewSections);
  };

  return (
    <section
      className={`Service2-container ${
        showNewSections ? "expanded" : "collapsed"
      }`}
    >
      <ul className="Services-list">
        {/* Sections existantes */}
        {services.map((service, index) => (
          <li key={index}>
            <div className="ligne no_scroll"></div>
            <div className="services-container no_scroll">
              <h2 className="no_scroll">{service.title}</h2>
              <p className="no_scroll">{service.desc}</p>
            </div>
          </li>
        ))}

        {showNewSections &&
          newSections.map((section, index) => (
            <li key={`new-${index}`}>
              <div className="ligne no_scroll"></div>
              <div className="services-container no_scroll">
                <h2 className="no_scroll">{section.title}</h2>
                <p className="no_scroll">{section.desc}</p>
              </div>
            </li>
          ))}

        {/* Bouton pour afficher/masquer les sections */}
        <div className="plus" onClick={toggleSections}>
          +
        </div>
      </ul>
      <article>
        <h3>
          Faites bosser vos chiffres,
          <br /> pas vous.
        </h3>
        <Link to="#contact" className="btn Service-btn">
         Parlons chiffres <svg xmlns="http://www.w3.org/2000/svg" className="arrow-icon blue" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
        </Link>
      </article>
    </section>
  );
};

export default Service2;